<div class="cat__core__widget">
    <div class="cat__core__step clearfix">
        <span class="cat__core__step__digit">
            <ng-content select=".widget-icon"></ng-content>
        </span>
        <div class="cat__core__step__desc">
            <span class="cat__core__step__title text-uppercase">{{title}}</span>
            <ng-content select=".widget-content"></ng-content>
        </div>
    </div>
</div>